'use client';

import { createContext, ReactNode, useContext } from 'react';
import { AccountsState, useAccounts } from '../hooks/useAccounts';

const AccountsContext = createContext<AccountsState | undefined>(undefined);

type AccountsProviderProps = {
    children: ReactNode;
};

export const AccountsProvider = ({ children }: AccountsProviderProps) => {
    const value = useAccounts();

    return <AccountsContext.Provider value={value}>{children}</AccountsContext.Provider>;
};

export const useAccountsContext = () => {
    const context = useContext(AccountsContext);
    if (!context) {
        throw new Error('useAccountsContext must be used within an AccountsProvider');
    }

    return context;
};
